/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 13/10/21
 */
import React, {memo} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import NomenclaturesAreaTypeApiService from '@/modules/settings/services/NomenclaturesAreaTypeApiService';

const ClientSelectAreaType = ({value, filters, onChange, ...props}) => {
  return (
    <SelectElementCmp
      queryKey={'client-area-type'}
      filters={filters}
      service={NomenclaturesAreaTypeApiService}
      includeValue={''}
      value={typeof value === 'object' ? value?.name : value}
      onChange={onChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      canAdd
      {...props}
    />
  );
};

ClientSelectAreaType.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  filters: PropTypes.object,
};

export default memo(ClientSelectAreaType);
